var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelopeOutline = function SvgEnvelopeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.5 4a2.75 2.75 0 0 1 2.75 2.75v10.5A2.75 2.75 0 0 1 19.5 20h-15a2.75 2.75 0 0 1-2.75-2.75V6.75A2.75 2.75 0 0 1 4.5 4zm1.75 5.113q-.145.12-.309.222l-7.5 4.615a2.75 2.75 0 0 1-2.882 0l-7.5-4.615a3 3 0 0 1-.309-.222v8.137c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75zM4.5 5a1.75 1.75 0 0 0-1.75 1.75v.243l.015.225c.067.52.365.987.818 1.265l7.5 4.616a1.75 1.75 0 0 0 1.834 0l7.5-4.616a1.75 1.75 0 0 0 .818-1.265l.015-.225V6.75A1.75 1.75 0 0 0 19.5 5z"
  })));
};
export default SvgEnvelopeOutline;